import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useSondertagContext } from "../context/sondertagContext";
import KsbActionButton from "../../../2_ksbHub/components/KsbActionButton";
import useSondertagPDF from "../hooks/useSondertagPDF";
import { LeaderboardIcon } from "../../../2_ksbHub/icons/icons";

export default function SondertagRankingDialog({
  open,
  onClose,
  ranking = [],
}) {
  const { isMobile } = useAppContext();
  const { teacherStats } = useSondertagContext();
  const { generateRankingPDF } = useSondertagPDF();

  function formatAbbr(abbr) {
    if (!abbr) return "";

    const clean = abbr.trim().toLowerCase();

    if (clean.length <= 2) {
      return clean.toUpperCase(); // fallback
    }

    return (
      clean[0].toUpperCase() +
      clean.slice(1, -1) +
      clean[clean.length - 1].toUpperCase()
    );
  }

  const suggestion = Object.entries(teacherStats || {})
    .map(([abbr, t]) => ({
      abbr,
      ...t,
      deficit: t.target - t.actual,
    }))
    .filter((t) => t.target > 0) // ✅ safety
    .sort((a, b) => b.deficit - a.deficit)[0]; // ✅ BEST candidate

  const suggestedAbbr = formatAbbr(suggestion?.abbr);

  const sortedRanking = [...ranking].sort(
    (a, b) => b.target - b.actual - (a.target - a.actual),
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth={isMobile ? "sm" : "xs"}>
      <DialogTitle>Arbeitsverteilung Lehrpersonen</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
          Empfehlung:
        </Typography>

        <Typography variant="body2">
          Nächster Einsatz: <strong>{suggestedAbbr}</strong>
        </Typography>

        <Typography variant="caption" sx={{ opacity: 0.7 }}>
          Aktuell: {suggestion?.actual ?? 0} /{" "}
          {suggestion?.target?.toFixed(1) ?? "0.0"} (
          {((suggestion?.ratio ?? 0) * 100).toFixed(0)}%)
        </Typography>
        <Divider sx={{ mt: 1, mb: 1 }} />

        <KsbActionButton
          onClick={generateRankingPDF}
          icon={<LeaderboardIcon />}
          label="Ranking drucken"
        />

        <Divider sx={{ mt: 1, mb: 1 }} />

        {sortedRanking.map((t, i) => (
          <Box
            key={t.abbr}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 0.5,
              borderBottom: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <Typography variant="body2" sx={{ textTransform: "none" }}>
              {i + 1}. {formatAbbr(t.abbr)}
            </Typography>

            <Typography variant="body2">
              {t.actual} / {t.target.toFixed(1)} ({(t.ratio * 100).toFixed(0)}%)
            </Typography>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
}
